import type { Ctx } from '@milkdown/kit/ctx';
import { renderToStaticMarkup } from 'react-dom/server';
import { Paperclip } from '@phosphor-icons/react';

import { pickAndUploadAttachmentFromCtx } from './attachmentUpload';

/** Type for slash menu item configuration (matches Crepe's SlashMenuItem) */
export interface SlashMenuItemConfig {
  label: string;
  icon: string;
  onRun: (ctx: Ctx) => void;
}

/** Slash menu item for inserting file attachments (PDF, Word, Excel, PowerPoint). */
export const AttachmentSlashMenuItems = {
  file: (): SlashMenuItemConfig => ({
    label: 'File',
    icon: renderToStaticMarkup(<Paperclip size={20} weight="bold" />),
    onRun: pickAndUploadAttachmentFromCtx,
  }),
};
